import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 26px;
  line-height: 30px;
  text-align: center;
  color: #322665;
  font-weight: 500;
`;
